import React, { Component } from "react";
import { View, ScrollView, Image, Text } from 'react-native';
import { connect } from "react-redux";

import Header from "../../../components/Header";
import { ContainerDesc, RegistrationProgress, EditInputFiled, EditPasswordFiled } from "../../../components";
import { checkUsername, userRegister } from '../../../action';
import { getServerResponse, phoneNumberFormate } from "../../../functions";
import styles from "../../../styles";
import { Button } from "../../../components/form";

import error_ic from "../../../assets/icon/Error.png";
import success_ic from "../../../assets/icon/check_ic.png";
import { global } from "../../../const";
import Loader from "../../../components/Loaders";
import localize from "../../../localize";


class ConfirmDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            progress: 4,
            isLoading: false,

            username: "",
            password: "",
            security_email: '',
            security_phone: '',
            recoveryOption: 'phone',

            userMessage: null,
            securityMessage: null,
            error: null,
        }
    }

    componentDidMount() {
        if (!this.props.registerUser) {
            this.props.history.push({ pathname: "Create-Account" })
            return;
        }

        this.setState(this.props.registerUser)
        this.setState({ recoveryOption: this.props.registerUser.security_email !== '' ? 'email' : 'phone' })
    }


    onRegister = async () => {
        try {
            const { username, password, security_email, security_phone, userMessage, securityMessage } = this.state;
            this.setState({ error: '' })
            this.setState({ isLoading: true })

            if (userMessage !== undefined && userMessage !== null) return this.setState({ error: userMessage });
            if (securityMessage !== undefined && securityMessage !== null) return this.setState({ error: securityMessage });

            let result = await this.props.userRegister({ username, password, security_email, security_phone });
            this.setState({ isLoading: false })

            // if(result.status === 200) return window.navigation(this, 'join_family')
            // if(result.status === 201) return window.navigation(this, 'dashboard')
            if (result.status === 200 || result.status === 201) {
                if (global.isNative)
                    return this.props.navigation.navigate("SignupSuccess");
                return this.props.history.push({ pathname: "Signup-Success" });
            }


            return this.setState({ error: result.message })
        } catch (error) {
            this.setState({ isLoading: false })
            return this.setState({ error: localize.Something_is_wrong })
        }
    }


    render() {
        const { progress, userMessage, username, password, security_email, security_phone, securityMessage, error, recoveryOption, isLoading } = this.state;

        return (
            <View style={styles.container}>
                <Header title={localize.Confirm_Details} goBack={() => this.props.history.goBack()} />
                <ScrollView keyboardShouldPersistTaps="always">

                    <RegistrationProgress progress={progress} />

                    <View style={{ margin: 15 }}>

                        <ContainerDesc title={localize.Review_your_account_details_and_make_sure_everything_is_accurate} />

                        <EditInputFiled
                            lable={localize.user_name}
                            value={username}
                            onChange={this.onUsernameChange}
                            style={!userMessage ? styles.borderGrey : userMessage !== null ? styles.borderAlert : username !== styles.borderGrey ? styles.borderGreen : styles.borderGrey}

                            rightComponent={!userMessage ? null : userMessage !== null ?
                                <Image source={error_ic} resizeMode="contain" style={{ height: 18, width: 18 }} />
                                : username !== null ? <Image source={success_ic} resizeMode="contain" style={{ height: 18, width: 18 }} /> : null}
                            errorMessage={userMessage}
                        />

                        <EditPasswordFiled
                            lable={localize.password}
                            value={password}
                        />

                        {
                            recoveryOption === 'email' ?
                                <EditInputFiled
                                    lable={localize.PASSWORD_RESET}
                                    value={security_email}
                                    onChange={this.onEmailChange('security_email', 'securityMessage')}
                                    style={!securityMessage ? styles.borderGrey : securityMessage !== null ? styles.borderAlert : security_email !== "" ? styles.borderGreen : styles.borderGrey}
                                    errorMessage={securityMessage}
                                /> : null
                        }
                        {
                            recoveryOption === 'phone' ?
                                <EditInputFiled
                                    lable={localize.PASSWORD_RESET}
                                    value={phoneNumberFormate(security_phone)}
                                    keyboardType='phone-pad'
                                    onChange={this.onPhoneChange}
                                    style={!securityMessage ? styles.borderGrey : securityMessage !== null ? styles.borderAlert : security_phone !== "" ? styles.borderGreen : styles.borderGrey}
                                    errorMessage={securityMessage}
                                /> : null
                        }

                        <Text style={[styles.errorTitle, { textAlign: 'center', paddingVertical: 30, paddingHorizontal: 20 }]}>{error}</Text>

                        <Button
                            title={localize.Create_Account}
                            onPress={this.onRegister}
                        />

                    </View>

                </ScrollView>
                <Loader visible={isLoading} />
            </View>
        );
    }

    onUsernameChange = async (username) => {
        this.setState({ username });
        let response = await this.props.checkUsername(username);
        return this.setState({ userMessage: response.message, validUsername: response.validUsername })
    }

    onEmailChange = (state, message) => async (email) => {
        try {
            let error = null;
            this.setState({ [state]: email });
            const response = await getServerResponse({ cmd: "WcnUser1.checkEmail", email });
            if (response) {
                if (response === 1) {
                    error = localize.Invalid_format_of_email_address;
                }
            }
            return this.setState({ [message]: error });
        } catch (error) {

        }
    }

    onPhoneChange = async (phone) => {
        let securityMessage = this.state.securityMessage;
        phone = phone.replace(/-/g, '');
        this.setState({ security_phone: phone });
        try {
            phone = phone.replace(/-/g, '');
            const response = await getServerResponse({ cmd: "WcnUser1.checkPhone", phone });
            if (response === 200) securityMessage = null
            else securityMessage = localize.Invalid_letters_detected_in_phone_number
        } catch (err) {

        }
        return this.setState({ securityMessage });
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        checkUsername: request => checkUsername(request),
        userRegister: request => dispatch(userRegister(request)),
    };
}

const mapStateToProps = ({ setting, auth }) => {
    return { height: setting.height, registerUser: auth.registerUser };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDetails);